<template>
  <div class="wraper">
    <el-row class="top">
      <span>矩阵报表</span>
      <el-tooltip placement="right">
        <div slot="content">
          矩阵报表：以专放率为标准，将冰柜进行分类：
          <br />问题冰柜（专放率小于33%）、金牛冰柜（专放率33%-66%）、明星冷柜（专放率>66%）。
          <br />累计客流：分类内所有大数据冷柜客流量总和(开关门次数-补货次数) 。
          <br />
          平均日客流：分类内平均每台设备每天客流量。 <br />
          平均专放率：分类内所有大数据冷柜纯净度平均值。 <br />
          累计销售额：分类内所有大数据冷柜销售额量总和(排除补货、退货状态后，各商品销售数量*对应单价后金额总和)
          。 <br />
          平均销售额：分类内平均每台设备每天额销售额 。 <br />
          累计销量：分类内所有大数据冷柜销量总和(排除补货、退货状态后，各商品销售数量总和）。
          <br />
          平均销量：分类内平均每台设备每天的销售额。
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
      <el-date-picker
        size="mini"
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable="clearDate"
      >
      </el-date-picker>
      <el-button size="mini" type="primary" @click="search">查询</el-button>
      <div class="export_btn">
        <exporter
          :setting="setting"
          :url="getListUrl"
          :date="date"
          :exportName="exportName"
        ></exporter>
      </div>
    </el-row>
    <deviceSearchBox
      :postParams="postParams"
      @getSearchSelect="searchTable"
    ></deviceSearchBox>

    <div id="selectdiv">
      冰柜分组
    </div>
    <!-- echarts图 -->
    <el-row style="margin-bottom:60px;height:500px">
      <div
        style="display: flex;
    justify-content: space-between;"
      >
        <div class="spanClass">
          <span
            v-for="(item, index) in reportList"
            @click="indexClick(index, item)"
            :key="index"
            :class="{ active: index == isActive }"
            >{{ item }}</span
          >
        </div>
        <div class="days">
          <span @click="dayClick()">天</span>
          <span class="active" @click="weekClick()">周</span>
          <span @click="mounthClick()">月</span>
        </div>
      </div>
      <div style="width:100%; min-height:500px" id="main"></div>
    </el-row>
    <div class="shouQi" ref="content" @click="showTable()">
      收起明细数据 ^
    </div>
    <transition @enter="enter" @leave="leave" :css="false">
      <el-row v-if="isShow">
        <report
          :setting="setting"
          :list="list"
          :date="date"
          @changeSort="handleSun"
        ></report>
        <!-- <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row> -->
      </el-row>
    </transition>
  </div>
</template>

<script>
import Report from "../../components/Report";
import exporter from "../../components/exporter";
import deviceSearchBox from "../devices/components/deviceSearchBox";
import * as echarts from "echarts";
import gsap from "gsap";
export default {
  name: "reports",
  components: {
    Report,
    exporter,
    deviceSearchBox
  },
  data() {
    return {
      exportName: "分组报表",
      getListUrl: "data/getDataReport_classify",
      date: this.getDefaultDay(),
      active: "active",
      isShow: true,
      isActive: 0,
      xData: [],
      sData: [],
      clearDate: false,

      groupName: [],
      putAssetsNum: [],
      sumCustomerFlow: [],
      avgCustomerFlow: [],
      avgPurity: [],
      sumSalesNum: [],
      avgSalesNum: [],

      sumSalesAmount: [],
      avgSalesAmount: [],

      reportList: [
        "投放设备数量",
        "累计客流（台）",
        "平均客流（台）",
        "平均专放率 （%）",
        "累计销量（台）",
        "平均销量（台）",
        "累计销售额（台）",
        "平均销售额（台）"
      ],
      postParams: {
        areaCompanyId: "",
        provinceBranchCompanyId: "",
        productModelType: "",
        agencyType: "",
        channelType: "",
        secondChannelType: "",
        thirdChannelType: "",
        dealerCompanyId: "",
        cityCode: "",
        marketType: "",
        provinceCode: "",
        putPolicy: "",
        storeId: "",
        keyWord: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24;
        }
      },
      currentPage: 1,
      setting: {
        isShowSelect: false,
        isShowIndex: false,
        tHeader: [
          {
            dataItem: "groupName",
            dataName: "分组名称",
            width: "130px"
          },
          {
            dataItem: "putAssetsNum",
            dataName: "投放设备数量",
            width: "130px"
          },
          {
            dataItem: "sumCustomerFlow",
            dataName: "累计客流（台）",
            width: "150px"
          },
          {
            dataItem: "avgCustomerFlow",
            dataName: "平均客流（台）",
            width: "150px"
          },
          {
            dataItem: "avgPurity",
            dataName: "平均专放率 （%）",
            width: "180px"
          },
          {
            dataItem: "sumSalesNum",
            dataName: "累计销量（台）",
            width: "180px"
          },
          {
            dataItem: "avgSalesNum",
            dataName: "平均销量（台）",
            width: "150px"
          },
          {
            dataItem: "sumSalesAmount",
            dataName: "累计销售额（台）",
            width: "180px"
          },
          {
            dataItem: "avgSalesAmount",
            dataName: "平均销售额（台）",
            width: "180px"
          }
        ],
        isShowPlay: true,
        isShowDelBtn: false,
        isShowEditBtn: false,
        isShowInfoBtn: true,
        isShowAssetsBtn: true,
        infoUrl: "channelDetail",
        btnsWidth: "250px"
      },
      list: [],
      total: 0,
      pageSize: 10
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getDefaultDay() {
      let date = new Date();
      let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8);
      let startyear = startdate.getFullYear();
      let startmonth = startdate.getMonth() + 1;
      if (startmonth < 10) {
        startmonth = "0" + startmonth;
      }
      let startday = startdate.getDate();
      if (startday < 10) {
        startday = "0" + startday;
      }
      startdate = startyear + "-" + startmonth + "-" + startday;
      let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
      let endyear = enddate.getFullYear();
      let endmonth = enddate.getMonth() + 1;
      if (endmonth < 10) {
        endmonth = "0" + endmonth;
      }
      let endday = enddate.getDate();
      if (endday < 10) {
        endday = "0" + endday;
      }
      enddate = endyear + "-" + endmonth + "-" + endday;
      return [startdate, enddate];
    },
    searchTable() {},
    getList(val) {
      let url = this.getListUrl;
      let paramsObj = this.postParams;
      let params = {
        startDay: this.date[0],
        endDay: this.date[1],
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      if (val != undefined) {
        params.order = val.order;
        params.prop = val.prop;
      }
      for (let k in paramsObj) {
        if (paramsObj[k] != "") params[k] = paramsObj[k];
      }
      let _this = this;
      this.$ajax
        .post(url, params)
        .then(this.getListSucc)
        .catch(function(res) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    getListSucc(res) {
      if (res.data && res.data.code === 200) {
        const data = res.data.data;
        this.list = data.list;
        // this.total = data.total;
        this.processingData(data.list);
      } else {
        let errMsg = "未知错误";
        if (res.data.msg) {
          errMsg = res.data.msg;
        }
        this.$message.error(errMsg);
      }
    },
    // 处理数据
    processingData(data) {
      (this.groupName = []),
        (this.putAssetsNum = []),
        (this.sumCustomerFlow = []),
        (this.avgCustomerFlow = []),
        (this.avgPurity = []),
        (this.sumSalesNum = []),
        (this.avgSalesNum = []),
        (this.sumSalesAmount = []),
        (this.avgSalesAmount = []),
        // console.log("处理数据的message",data);
        data.forEach(item => {
          this.groupName.push(item.groupName);

          this.putAssetsNum.push(item.putAssetsNum);

          this.sumCustomerFlow.push(item.sumCustomerFlow);
          this.avgCustomerFlow.push(item.avgCustomerFlow);
          this.avgPurity.push(item.avgPurity);
          this.sumSalesNum.push(item.sumSalesNum);

          this.avgSalesNum.push(item.avgSalesNum);
          this.sumSalesAmount.push(item.sumSalesAmount);

          this.avgSalesAmount.push(item.avgSalesAmount);
        });
      this.indexClick(this.isActive);
    },
    search() {
      this.getList();
    },
    drawCharts(xData, sData) {
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "none" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "5%"
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
                width: 1 //这里是为了突出显示加上的
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
                width: 1 //这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            type: "bar",
            barMaxWidth: "20%",
            itemStyle: {
              normal: {
                color: "rgb(253, 213, 151)"
              }
            },

            data: sData,
            label: {
              show: true,
              position: "top",
              color: "#fff"
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    // 变换颜色
    indexClick(index, item) {
      this.isActive = index;

      switch (index) {
        case 0:
          this.drawCharts(this.groupName, this.putAssetsNum);
          break;
        case 1:
          this.drawCharts(this.groupName, this.sumCustomerFlow);
          break;
        case 2:
          this.drawCharts(this.groupName, this.avgCustomerFlow);
          break;
        case 3:
          this.drawCharts(this.groupName, this.avgPurity);
          break;
        case 4:
          this.drawCharts(this.groupName, this.sumSalesNum);
          break;
        case 5:
          this.drawCharts(this.groupName, this.avgSalesNum);
          break;
        case 6:
          this.drawCharts(this.groupName, this.sumSalesAmount);
          break;
        case 7:
          this.drawCharts(this.groupName, this.avgSalesAmount);
          break;

        default:
          break;
      }
    },
    enter(el, done) {
      gsap.from(el, {
        scale: 0,
        // x:200,
        duration: 1,
        onComplete: done
      });
    },
    leave(el, done) {
      gsap.to(el, {
        scale: 0,
        // x:200,
        duration: 1,
        onComplete: done
      });
    },
    // 其他兄弟节点移除active 类
    siblings(elm) {
      var p = elm.parentNode.children;
      for (var i = 0, pl = p.length; i < pl; i++) {
        if (p[i] !== elm) {
          p[i].classList.remove("active");
        }
      }
    },
    // 转换时间
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month =
        time.getMonth() + 1 > 10
          ? time.getMonth() + 1
          : "0" + (time.getMonth() + 1);
      let day = time.getDate() > 10 ? time.getDate() : "0" + time.getDate();
      return year + "-" + month + "-" + day;
    },

    // 选择天
    dayClick() {
      var obj = document.getElementsByClassName("days")[0];
      var nowNode = obj.firstElementChild;
      this.siblings(nowNode);
      nowNode.classList.add("active");
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);

      this.date = [this.timeFormat(start), this.timeFormat(start)];
      this.search();
    },
    // 选择周
    weekClick() {
      var nowNodes = document
        .getElementsByClassName("days")[0]
        .getElementsByTagName("span");
      this.siblings(nowNodes[1]);
      nowNodes[1].classList.add("active");

      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      this.date = [this.timeFormat(start), this.timeFormat(end)];
      this.search();
    },
    // 选择月
    mounthClick() {
      var nowNodes = document
        .getElementsByClassName("days")[0]
        .getElementsByTagName("span");
      this.siblings(nowNodes[2]);
      nowNodes[2].classList.add("active");
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.date = [this.timeFormat(start), this.timeFormat(end)];
      this.search();
    },
    showTable() {
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.$refs.content.innerHTML = "收起明细数据 ^";
      } else {
        this.$refs.content.innerHTML = "展开明细数据 v";
      }
    },

    // handleSizeChange(val) {
    //   // console.log('每页 '+val+' 条');
    //   this.pageSize = val;
    //   this.currentPage = 1;
    //   this.getList();
    //   // console.log(this.pageSize);
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val;
    //   this.getList();
    // },
    handleSun(val) {
      this.getList(val);
    },
    searchTable() {
      // console.log(this.postParams,"00")
      this.getList();
    }
  }
};
</script>
<style scoped>
.active {
  background: rgb(251, 170, 123);
  color: #000;
}
.top {
  height: 50px;
}

.pages {
  padding-top: 10px;
  text-align: center;
}
#selectdiv {
  margin-bottom: 10px;
}
.spanClass {
  width: 60%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  font-size: 14px;
}
.spanClass span {
  display: inline-block;
  border: 1px solid rgb(251, 170, 123);
  padding: 3px;
  margin-top: 5px;
  margin-right: 5px;
  cursor: pointer;
  flex-shrink: 1;
  padding: 5px 10px;
}
.days span {
  display: inline-block;
  border: 1px solid rgb(251, 170, 123);
  padding: 3px 15px;
  float: left;
  margin-top: 5px;
  cursor: pointer;
}
.shouQi {
  display: inline-block;
  margin-bottom: 10px;
  cursor: pointer;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/reports/classRep.vue